export default function Records() {
  return (
    <div>
      RECORDS
    </div>
  );
}
